import { configureStore } from '@reduxjs/toolkit'
import { generateSlice } from 'client/fragments/listerFragment/store/reducer'
import { listenerMiddleware } from 'client/fragments/listerFragment/store/middleware/gtm'

export const generateStore = states => {
  const { reducer } = generateSlice(states.data)
  const store = configureStore({
    reducer: {
      data: reducer
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware().prepend(listenerMiddleware.middleware)
  })
  return { store }
}
